let projectTypeInfo = [
    {
        img: require('../img/projectTypes/product.png'),
        alt: "Product design logo",
        title: "New Product Development",
        description: "Investigating product need, design thinking & prototyping, conceptualizing key features, preparing go-to-market strategies"
    },
    {
        img: require('../img/projectTypes/environment.png'),
        alt: "Cycle",
        title: "Environmental Strategy",
        description: "Sustainability target planning, life cycle assessment, supply chain greening, carbon neutrality tactics, footprint & resource use reduction"
    },
    {
        img: require('../img/projectTypes/analysis.png'),
        alt: "Excel logo",
        title: "Target Market Research",
        description: "Understanding customer needs, classifying user profiles, competitive landscape overviews, market data analysis, opportunity sizing & positioning"
    },
    {
        img: require('../img/projectTypes/impact.png'),
        alt: "Money bags",
        title: "Impact Evaluation",
        description: "Codifying metrics, measurement tactics, stakeholder engagement & communication, quantitative and qualitative analysis of outcomes"
    }
];

export default projectTypeInfo;